import {
  CUSTOMER_ADMIN_ADD_FAVOURITE,
  CUSTOMER_ADMIN_FETCH_ALL_CONTACT,
  CUSTOMER_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  CUSTOMER_ADMIN_FILTER_CONTACT,
  CUSTOMER_ADMIN_GET_ALL_CONTACT,
  CUSTOMER_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  CUSTOMER_ADMIN_HANDLE_REQUEST_CLOSE,
  CUSTOMER_ADMIN_HIDE_CONTACT_LOADER,
  CUSTOMER_ADMIN_ON_ADD_CONTACT,
  CUSTOMER_ADMIN_ON_ALL_CONTACT_SELECT,
  CUSTOMER_ADMIN_ON_CONTACT_CLOSE,
  CUSTOMER_ADMIN_ON_CONTACT_SELECT,
  CUSTOMER_ADMIN_ON_DELETE_CONTACT,
  CUSTOMER_ADMIN_ON_DELETE_SELECTED_CONTACT,
  CUSTOMER_ADMIN_ON_FILTER_OPTION_SELECT,
  CUSTOMER_ADMIN_ON_SAVE_CONTACT,
  CUSTOMER_ADMIN_ON_TOGGLE_DRAWER,
  CUSTOMER_ADMIN_SHOW_MESSAGE,
  CUSTOMER_ADMIN_UPDATE_SEARCH_USER,
  CHANGE_CUSTOMER_ADMIN_DISPLAY,
  SET_CUSTOMER_IMAGE_FILE,
  SUBMIT_NEW_CUSTOMER_ADMIN,
  SUBMIT_NEW_CUSTOMER_ADMIN_RESPONSE,
  HANDLE_DATE_OF_BIRTH,
  FILL_ADMIN_CUSTOMER_SELECTED_DETAILS,
  CHANGE_ADD_CUSTOMER_STATE,
  CHANGE_EDIT_CUSTOMER_STATE,
  SUBMIT_EDIT_CUSTOMER_DETAILS,
  SUBMIT_EDIT_CUSTOMER_DETAILS_RESPONSE,
  CUSTOMER_CLEAR_FORM_DATA,
  SELECTED_CUSTOMER_DELETE,
  SELECTED_CUSTOMER_DELETE_RESPONSE,
  CUSTOMER_FAIL_RESPONSE,
  CUSTOMER_ON_HIDE_LOADER2,
  CUSTOMER_ON_SHOW_LOADER,
  REMOVE_CUSTOMER_IMAGE_FILE,
  REMOVE_CUSTOMER_IMAGE_FILE_PROFILE
} from "../constants/ActionTypes";

export const customerAdminFetchContacts = () => ({
  type: CUSTOMER_ADMIN_FETCH_ALL_CONTACT,
});

export const customerAdminFetchContactsSuccess = contact => ({
  type: CUSTOMER_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  payload: contact,
});
export const customerAdminShowContactMessage = message => ({
  type: CUSTOMER_ADMIN_SHOW_MESSAGE,
  payload: message,
});
export const customerAdminAddFavourite = data => ({
  type: CUSTOMER_ADMIN_ADD_FAVOURITE,
  payload: data,
});
export const customerAdminOnContactSelect = data => ({
  type: CUSTOMER_ADMIN_ON_CONTACT_SELECT,
  payload: data,
});

export const customerAdminOnAddContact = () => ({
  type: CUSTOMER_ADMIN_ON_ADD_CONTACT,
  payload: "",
});
export const customerAdminOnContactClose = () => ({
  type: CUSTOMER_ADMIN_ON_CONTACT_CLOSE,
  payload: "",
});
export const customerAdminOnFilterOptionSelect = option => ({
  type: CUSTOMER_ADMIN_ON_FILTER_OPTION_SELECT,
  payload: option,
});
export const customerAdminOnSaveContact = data => ({
  type: CUSTOMER_ADMIN_ON_SAVE_CONTACT,
  payload: data,
});
export const customerAdminOnDeleteContact = data => ({
  type: CUSTOMER_ADMIN_ON_DELETE_CONTACT,
  payload: data,
});
export const customerAdminOnDeleteSelectedContact = () => ({
  type: CUSTOMER_ADMIN_ON_DELETE_SELECTED_CONTACT,
  payload: "",
});
export const customerAdminFilterContact = userName => ({
  type: CUSTOMER_ADMIN_FILTER_CONTACT,
  payload: userName,
});
export const customerAdminGetAllContact = () => ({
  type: CUSTOMER_ADMIN_GET_ALL_CONTACT,
  payload: "",
});
export const customerAdminGetUnselectedAllContact = () => ({
  type: CUSTOMER_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  payload: "",
});
export const customerAdminOnAllContactSelect = () => ({
  type: CUSTOMER_ADMIN_ON_ALL_CONTACT_SELECT,
  payload: "",
});
export const customerAdminUpdateContactUser = userName => ({
  type: CUSTOMER_ADMIN_UPDATE_SEARCH_USER,
  payload: userName,
});
export const customerAdminOnToggleDrawer = () => ({
  type: CUSTOMER_ADMIN_ON_TOGGLE_DRAWER,
});
export const customerAdminHandleRequestClose = () => ({
  type: CUSTOMER_ADMIN_HANDLE_REQUEST_CLOSE,
});
export const customerAdminHideContactLoader = () => ({
  type: CUSTOMER_ADMIN_HIDE_CONTACT_LOADER,
});

export const changeCustomerAdminDisplay = payload => ({
  type: CHANGE_CUSTOMER_ADMIN_DISPLAY,
  payload,
});

export const setCustomerImageFile = payload => ({
  type: SET_CUSTOMER_IMAGE_FILE,
  payload,
});

export const removeCustomerImageFileProfile = () => ({
  type:REMOVE_CUSTOMER_IMAGE_FILE_PROFILE
})
export const submitNewCustomerAdmin = payload => ({
  type: SUBMIT_NEW_CUSTOMER_ADMIN,
  payload,
});

export const submitNewCustomerAdminResponse = payload => ({
  type: SUBMIT_NEW_CUSTOMER_ADMIN_RESPONSE,
  payload,
});

export const handleDateOfBirth = payload => ({
  type: HANDLE_DATE_OF_BIRTH,
  payload,
});

export const fillAdminCustomerSelctedDetails = payload => ({
  type: FILL_ADMIN_CUSTOMER_SELECTED_DETAILS,
  payload,
});

export const removeCustomerImageFile = () =>({
  type:REMOVE_CUSTOMER_IMAGE_FILE
})
export const changeAddCustomerState = payload => ({
  type: CHANGE_ADD_CUSTOMER_STATE,
  payload,
});

export const changeEditCustomerState = payload => ({
  type: CHANGE_EDIT_CUSTOMER_STATE,
  payload,
});

export const submitEditCustomerDetails = payload => ({
  type: SUBMIT_EDIT_CUSTOMER_DETAILS,
  payload,
});

export const submitEditCustomerDetailsResponse = payload => ({
  type: SUBMIT_EDIT_CUSTOMER_DETAILS_RESPONSE,
  payload,
});

export const customerClearFormData = () => ({
  type: CUSTOMER_CLEAR_FORM_DATA,
});

export const selectedCustomerDelete = payload => ({
  type: SELECTED_CUSTOMER_DELETE,
  payload,
});
export const selectedCustomerDeleteResposne = payload => ({
  type: SELECTED_CUSTOMER_DELETE_RESPONSE,
  payload,
});

export const customerFailResponse = payload => ({
  type: CUSTOMER_FAIL_RESPONSE,
  payload,
});

export const customerOnHideLoader = payload => ({
  type: CUSTOMER_ON_HIDE_LOADER2,
  payload,
});

export const customerOnShowLoader = payload => ({
  type: CUSTOMER_ON_SHOW_LOADER,
  payload,
});



// WEBPACK FOOTER //
// ./actions/CustomerAdminAction.js